export const getCredentialConnectionExecutionPriority = (status) => {
  const normalizedStatus = String(status || '')
    .trim()
    .toLowerCase();

  if (normalizedStatus === 'valid') {
    return 2;
  }

  if (normalizedStatus === 'unsupported') {
    return 1;
  }

  return 0;
};
